<div class="flex-row">
  <div class="flex-1"></div>

  <div class="flex-3">
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="form-content">
      <h1 class="margin-bottom-25 center-text mt-3 registration-title">Create a Customer Account</h1>

      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput type="text" matInput formControlName="firstName">

        @if (formControls.firstName.hasError('required')) {
          <mat-error>First name is required.</mat-error>
        }

      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="lastName">

        @if (formControls.lastName.hasError('required')) {
          <mat-error>Last name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email Address</mat-label>
        <input matInput (change)="checkProperEmail()" type="email" formControlName="emailAddress">

        @if (formControls.emailAddress.hasError('required')) {
          <mat-error>Email is required.</mat-error>
        }
      </mat-form-field>

      @if (!properEmail && !formControls.emailAddress.pristine) {
        <p class="email-warn">Email is invalid.</p>
      }


      <mat-form-field appearance="outline">
        <mat-label>Address</mat-label>
        <input matInput type="text" formControlName="address">

        @if (formControls.address.hasError('required')) {
          <mat-error>Address is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput type="text" formControlName="city">

        @if (formControls.city.hasError('required')) {
          <mat-error>City is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>State</mat-label>
        <mat-select (change)="selectState($event)" formControlName="state">

          @for (state of states; track state) {
            <mat-option [value]="state">{{state}}</mat-option>
          }
        </mat-select>

        @if (formControls.state.hasError('required')) {
          <mat-error>State is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Zip Code</mat-label>
        <input matInput type="text" formControlName="zipCode" minlength="5" maxlength="5">

        @if (formControls.zipCode.hasError('required')) {
          <mat-error>Zip code is required.</mat-error>
        }

        @if (formControls.zipCode.hasError('minlength')) {
          <mat-error>Zip code must be 5 digits.</mat-error>
        }
        
        @if (formControls.zipCode.hasError('maxlength')) {
          <mat-error>Zip code must be 5 digits.</mat-error>
        }

        @if (formControls.zipCode.hasError('pattern')) {
          <mat-error>Zip code is invalid.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date of Birth</mat-label>
        <input matInput formControlName="dateOfBirth" [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        
        @if (formControls.dateOfBirth.hasError('required')) {
          <mat-error>Date of Birth is required.</mat-error>
        }

        @if (formControls.dateOfBirth.hasError('email')) {
          <mat-error>Date of Birth is invalid.</mat-error>
        }

      </mat-form-field>

      <mat-form-field class="mb-3" appearance="outline">
        <mat-label>Primary Phone</mat-label>
        <input matInput type="text" formControlName="primaryPhoneNumber" minlength="12" maxlength="12">
        <mat-hint>Ex.123-123-1234</mat-hint>

        @if (formControls.primaryPhoneNumber.hasError('required')) {
          <mat-error>Primary phone number is required.</mat-error>
        }

        @if (formControls.primaryPhoneNumber.hasError('minlength')) {
          <mat-error>Invalid Phone Number,<br>Ex. 123-123-1234</mat-error>
        }

        @if (formControls.primaryPhoneNumber.hasError('pattern')) {
          <mat-error>Invalid Phone Number</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Secondary Phone</mat-label>
        <input matInput type="text" formControlName="secondaryPhoneNumber" maxlength="12">
        <mat-hint>Ex.123-123-1234</mat-hint>

        @if (formControls.secondaryPhoneNumber.hasError('pattern')) {
          <mat-error>Invalid Phone Number</mat-error>
        }
      </mat-form-field>

      @if (errorMessage !== null) {
        <div class="error-text">
          <p>{{errorMessage}}</p>
        </div>
      }

      <div class="form-group float-right width-100">
        
        @if (saving) {
          <mat-progress-bar style="height: 4px; width: 100%;" mode="indeterminate"></mat-progress-bar>
        }

        @if (!saving) {
          <button mat-raised-button style="border-radius: 4px" color="primary" [disabled]="loading || !registrationForm.valid || !properEmail" type="submit" class="btn btn-primary btn-size mt-2">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            Register
          </button>
        }
      </div>
    </form>
  </div>

  <div class="flex-4 image-container">
    <h1 class="registration-title">IN AN UPPER WORLD</h1>

    <img src={{registrationImage}}>
  </div>
</div>